import OtpInput from "../Common/Otp/OTPReader";
import React, { useState } from 'react';
import { Button, Modal } from "react-bootstrap";
import LoaderButton from "../Common/LoaderButton";

function VerifyOTP({ handleVerifyOtp, loading, open = false, handleOtp, otp }) {
    const otpLength = 6;


    const handleClose = () => setShow(false);
    const [show, setShow] = useState(open);

    return (

        <React.Fragment>
            <Modal
                className="fade contest_input_modal"
                show={show}
                onHide={handleClose}
                backdrop='static'
                keyboard={false}
            >
                <Modal.Dialog className="modal-dialog-centered">
                    <Modal.Body className="text-center">
                        <div class="text-center m-auto">
                            <p class="text-muted mb-4">Please enter your OTP sent via SMS</p>
                        </div>
                        <div class="form-group">
                            <div class="row">
                                <OtpInput
                                    OTPLength={otpLength}
                                    disabled={false}
                                    value={otp}
                                    onChange={handleOtp}
                                    inputClassName="form-control Skip h-52"
                                    otpType="number"
                                />
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="border-0 justify-content-center pb-5">
                        <button type="button" class="btn btn-outline-dark justify-content-cente min-width" data-dismiss="modal" onClick={handleClose}>Cancel</button>
                        <LoaderButton
                            name='Submit Verification Code'
                            className='btn btn-chartreuse justify-content-center min-width'
                            onButtonClick={handleVerifyOtp}
                            loading={loading}
                        />
                    </Modal.Footer>
                </Modal.Dialog>

            </Modal>
        </React.Fragment>

    )
}

export default VerifyOTP;